import {
  ClosePageWrapper,
  LeftPart,
  RightPart,
} from "@/pages/authorization-management/views/auth-close-page/atom";
import AuthProfileImage from "@/assets/icons/auth/auth-profile";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { AuthStatementModal } from "@/pages/authorization-management/components/auth-statement-modal";

export function AuthClosePage() {
  const t = getTranslateNsT("center");
  const { setOpenAuthStatementDialog } = useAuthManageStore();

  return (
    <ClosePageWrapper>
      <LeftPart>
        <div className="title">{t("header_user_tool_auth")}</div>
        <div className="tip">{t("auth_manage_tip")}</div>
        <button onClick={() => setOpenAuthStatementDialog(true)}>
          {t("user_auth_btn")}
        </button>
      </LeftPart>
      <RightPart>
        <AuthProfileImage />
      </RightPart>
      <AuthStatementModal />
    </ClosePageWrapper>
  );
}
